module.exports = __webpack_public_path__ + "img/custom-logo-w.3d8e9930.png";